class ScreenSizes {
}
ScreenSizes.xs = 576;
ScreenSizes.sm = 768;
ScreenSizes.md = 992;
ScreenSizes.lg = 1200;
ScreenSizes.xl = 1600;
export default ScreenSizes;
